import { Component, Inject, OnInit } from "@angular/core";
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidationErrors,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { UserStatus } from "app/_models/user-status";
import { AdminService } from "app/_services/admin.service";
import { AssetUserService } from "app/_services/asset-user.service";
declare const swal: any;

export function customEmailValidator(
  control: AbstractControl
): ValidationErrors | null {
  const email = control.value;
  const emailPattern = /^[a-z0-9._%+-]+@tsiplc\.com$/;

  if (!email) return null;

  if (email.length > 50) {
    return { invalidEmail: "Email must be 50 characters or fewer." };
  }

  if (!emailPattern.test(email)) {
    return {
      invalidEmail: "Please enter a valid lowercase @tsiplc.com email address.",
    };
  }

  return null;
}

@Component({
  selector: "app-add-asset-user",
  templateUrl: "./add-asset-user.component.html",
})
export class AddAssetUserComponent implements OnInit {
  addAssetUserForm: UntypedFormGroup;
  pageNumber: number;
  pageSize: number;
  userStatus: UserStatus[] = [];
  searchValue: string = "";

  constructor(
    private readonly assetUserService: AssetUserService,
    private readonly dialogRef: MatDialogRef<AddAssetUserComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly adminService: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.searchValue = data.searchValue;
    this.pageNumber = data.pageNumber;
    this.pageSize = data.pageSize;
  }
  ngOnInit(): void {
    this.initilizeForm();
    this.getUserStatus();
  }

  initilizeForm() {
    this.addAssetUserForm = this.formBuilder.group({
      employeeId: [
        null,
        [
          Validators.required,
          Validators.pattern("^\\s*[a-zA-Z0-9]+\\s*$"),
          Validators.maxLength(20),
        ],
      ],
      firstName: [
        null,
        [
          Validators.required,
          Validators.pattern("^(?![ .]+$)([a-zA-Z]+[ .]*)*$"),
          Validators.maxLength(20),
        ],
      ],
      lastName: [
        null,
        [
          Validators.required,
          Validators.pattern("^(?![ .]+$)([a-zA-Z]+[ .]*)*$"),
          Validators.maxLength(20),
        ],
      ],

      email: [null, [Validators.required, customEmailValidator]],
      mobileNumber: [
        null,
        [
          Validators.required,
          Validators.pattern("^[0-9]{10}$"), // Exactly 10 digits, only numbers
        ],
      ],
      appStatusId: [null, [Validators.required]],
    });
  }

  getUserStatus() {
    this.adminService.getUserStatus().subscribe((result) => {
      this.userStatus = result;
    });
  }

  saveAssetUser() {
    let model = {
      employeeId: this.addAssetUserForm.value.employeeId,
      firstName: this.addAssetUserForm.value.firstName,
      lastName: this.addAssetUserForm.value.lastName,
      email: this.addAssetUserForm.value.email,
      mobileNumber: this.addAssetUserForm.value.mobileNumber,
      appStatusId: this.addAssetUserForm.value.appStatusId,
    };
    this.assetUserService.saveAssetUser(model).subscribe(
      (data) => {
        if (data.didError) {
          swal({
            title: "",
            text: data.message,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        } else {
          swal({
            title: "",
            text: data.message,
            type: "success",
            confirmButtonClass: "btn btn-info",
          });
        }
        let result = {
          searchValue: this.searchValue,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        };
        this.dialogRef.close(result);
      },
      (error) => {
        let errorMessage =
          error.error?.title ??
          error.error ??
          "Something went wrong. Please contact admin.";

        // Check if it's a validation error response with the `errors` object
        if (error.error?.errors) {
          const allErrors = Object.values(error.error.errors).flat(); // Flatten all error arrays
          if (allErrors.length > 0) {
            errorMessage = allErrors[0]; // Use the first validation message
          }
        } else if (typeof error.error === "string") {
          errorMessage = error.error;
        } else if (error.error?.title) {
          errorMessage = error.error.title;
        }

        swal({
          title: "",
          text: errorMessage,
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      }
    );
  }

  close() {
    this.dialogRef.close();
  }
}
